import React from 'react';
import { Box, Typography, Alert, AlertTitle } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import { useMaintenanceContext } from '../../context/MaintenanceContext';
import { intl } from '../../i18n/provider';

const MaintenanceBanner = () => {
    const { isBlocked, getMessage, loading } = useMaintenanceContext();

    // Don't render anything while loading or if not blocked
    if (loading || !isBlocked) {
        return null;
    }

    // Get current locale from intl
    const currentLocale = intl?.locale || 'en';
    const message = getMessage(currentLocale);

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                padding: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Alert
                severity="warning"
                icon={<BuildIcon fontSize="large" />}
                sx={{
                    maxWidth: 600,
                    width: '100%',
                    fontSize: '1.1rem',
                    '& .MuiAlert-icon': {
                        fontSize: '2rem',
                    },
                }}
            >
                <AlertTitle sx={{ fontSize: '1.3rem', fontWeight: 'bold' }}>
                    {intl.formatMessage({ id: 'maintenance_title', defaultMessage: 'System Maintenance' })}
                </AlertTitle>
                <Typography variant="body1" sx={{ mt: 1 }}>
                    {message}
                </Typography>
            </Alert>
        </Box>
    );
};

export default MaintenanceBanner;
